module.exports = __webpack_public_path__ + "static/media/star-fb.6d7ab23e.png";